const PAYROLL_STATUS_META = {
  processed: { label: "Paid", tone: "success" },
  pending: { label: "Pending", tone: "warning" },
  failed: { label: "Failed", tone: "danger" },
  not_processed: { label: "Pending", tone: "muted" },
};

export function getCurrentMonthKey() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function formatFinancialYearLabel(monthKey) {
  const [year, month] = String(monthKey || getCurrentMonthKey())
    .split("-")
    .map((value) => Number(value));

  const startYear = month >= 4 ? year : year - 1;
  return `${startYear}-${String(startYear + 1).slice(-2)}`;
}

export function formatMonthHeading(monthKey) {
  const [year, month] = String(monthKey || getCurrentMonthKey())
    .split("-")
    .map((value) => Number(value));

  return new Intl.DateTimeFormat("en-IN", {
    month: "long",
    year: "numeric",
  }).format(new Date(year, month - 1, 1));
}

export function getPayrollStatusMeta(status) {
  return PAYROLL_STATUS_META[status] || PAYROLL_STATUS_META.not_processed;
}

export function createSalaryOverviewDonutStyle(summary) {
  const grossSalary = Number(summary?.grossSalary || 0);
  const totalDeductions = Number(summary?.totalDeductions || 0);
  const netSalary = Number(summary?.netSalary || 0);
  const total = Math.max(1, grossSalary + totalDeductions + netSalary);

  const values = [
    ["#4d8cf7", (grossSalary / total) * 100],
    ["#6acb7c", (totalDeductions / total) * 100],
    ["#ffbf47", (netSalary / total) * 100],
  ];

  let cursor = 0;
  const stops = values
    .filter(([, size]) => size > 0)
    .map(([color, size]) => {
      const stop = `${color} ${cursor}% ${cursor + size}%`;
      cursor += size;
      return stop;
    });

  return `conic-gradient(${stops.join(", ") || "#edf0f5 0% 100%"})`;
}

export function getFinancialYearOptions(payslips, monthKey) {
  const values = new Set(
    (payslips || [])
      .map((payslip) => payslip.financialYearLabel)
      .filter(Boolean)
      .map((label) => label.replace(/^FY\s+/i, ""))
  );

  values.add(formatFinancialYearLabel(monthKey));
  return Array.from(values).sort((left, right) => String(right).localeCompare(String(left)));
}

export function getMonthFilterOptions(payslips, yearLabel) {
  return (payslips || [])
    .filter((payslip) => payslip.financialYearLabel?.endsWith(yearLabel))
    .map((payslip) => ({
      value: payslip.monthKey,
      label: payslip.monthLabel,
    }));
}

export function triggerBlobDownload(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

export function downloadTextDocument(fileName, content) {
  const blob = new Blob([content], { type: "text/plain;charset=utf-8;" });
  triggerBlobDownload(blob, fileName);
}
